<template>
  <div>    
    <div class="col-12 lg:col-12 px-0">
      <Toolbar class="mb-2">
        <template #start>
          <div class="grid">
            <div class="col-12">
              <Dropdown class="w-full"
                v-model="selectedUnidadFiltro"
                :options="lstUnidades"
                optionLabel="UNIDAD_SUBRED"
                placeholder="Selecciona una unidad"
                :showClear="true"
                :filter="true"
                @change="cargaEquiposPorUnidad"
                @show="focusFilter"
              />
            </div>
          </div>
        </template>
        <template #end>          
          
          <download-excel 
            v-show="selectedUnidadFiltro"
            class="btn mr-2"
            :data="lstEquipos"
            :fields="fieldsExport"
            :stringifyLongNum="true"
            :name="selectedUnidadFiltro?selectedUnidadFiltro.UNIDAD + '.xls':''"
            >
              <Button label="Exportar"
              icon="pi pi-external-link"
              class="p-button-warning" />       
          </download-excel>
          <Button
            v-show="
              selectedUnidadFiltro && selectedUnidadFiltro.UNIDAD != 'TODOS'
            "
            label="Diagrama"
            icon="pi pi-sitemap"
            class="p-button-help mr-2"
            @click="verDiagrama"
          />
          <Button
            v-show="
              selectedUnidadFiltro && selectedUnidadFiltro.UNIDAD != 'TODOS'
            "
            label="Etiquetado"
            icon="pi pi-tags"
            class="p-button-info mr-2"
            @click="verEtiquetado"
          />
          <Button
            label="Nuevo"
            icon="pi pi-plus"
            class="p-button-success mr-2"
            @click="agregarEquipo"
          />
          <!-- <Button v-show="selectTipoReporte && selectTipoReporte.id>0" label="Exportar a Excel" icon="pi pi-download" class="p-button-help" @click="exportar($event)"></Button> -->
        
        </template>
      </Toolbar>
    </div>
    <DataTable
      v-if="
        selectedUnidadFiltro != null && selectedUnidadFiltro.SUBRED == 'TODOS'
      "
      :value="lstEquipos"
      v-model:expandedRows="expandedRows"
      dataKey="Id_equipo"
      ref="dt"
      v-model:filters="filters"
      :globalFilterFields="['MAC','UBICACION','NUM_SERIE','CONFIGURABLE','REF','Observacion',
      'ENLA_ENTRADA','ENLA_SALIDA','IP','MARCA','MODELO','UNIDAD','TIPO_DISPOSITIVO','SUBRED','POE']"
      :loading="loading"
      :paginator="true"
      :rows="20"
      responsiveLayout="scroll"
    >
      <template #header>
        <div class="table-header-container">
            <Button icon="pi pi-plus" label="Expandir todos" @click="expandAll" class="mr-2"/>
            <Button icon="pi pi-minus" label="Colapsar todos" @click="collapseAll" />
        </div>
        <div class="table-header">
          <h5>Equipos</h5>
          <span
            >Número de equipos {{ lstEquipos ? lstEquipos.length : 0 }}</span
          >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="text" v-model="filters['global'].value"  placeholder="Buscar..."/>
          </span>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>
      <Column :expander="true" headerStyle="width: 3rem" />
      <Column field="UNIDAD" header="UNIDAD" sortable></Column>
      <Column field="TIPO_DISPOSITIVO" header="DISPOSITIVO" sortable></Column>
      <Column field="MARCA" header="MARCA" sortable></Column>
      <Column field="MODELO" header="MODELO" sortable></Column>
      <Column header="IMAGEN">
        <template #body="slotProps">
          <img
            :src="
              '/assets/modelos/' +
              slotProps.data.MODELO.toLowerCase().trim().replace(' ', '') +
              '.png'
            "
            :alt="slotProps.data.MODELO.toLowerCase().trim().replace(' ', '')"
            class="product-image"
            @click="verImg('/assets/modelos/' +
              slotProps.data.MODELO.toLowerCase().trim().replace(' ', '') +
              '.png')"
          />
        </template>
      </Column>
      <Column field="IP" header="IP" sortable>
      <template #body="slotProps">
        <span style="color:blue;cursor: pointer;" @click="pingEquipo(slotProps.data.IP)">{{ slotProps.data.IP }}</span>
      </template>
      </Column>
      <Column :exportable="false">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success"
            @click="edit(slotProps.data)"
          />
          <Button
            style="margin-left: 8px"
            icon="pi pi-times"
            class="p-button-rounded p-button-danger"
            @click="borrar(slotProps.data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
          <Card>
            <template #content>
              <div class="grid">
                <div class="col-6">
                  <div class="grid">
                    <div class="col title">Ubicación</div>
                    <div class="col data">
                      {{ slotProps.data.UBICACION }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">Num. serie</div>
                    <div class="col data">
                      {{ slotProps.data.NUM_SERIE }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">MAC</div>
                    <div class="col data">
                      {{ slotProps.data.MAC }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">REFERENCIA</div>
                    <div class="col data">
                      {{ slotProps.data.REF }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">PUERTOS</div>
                    <div class="col data">
                      {{ slotProps.data.PUERTOS }}
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="grid">
                    <div class="col title">SERVICIO</div>
                    <div class="col data">
                      {{ slotProps.data.TIPO_SERVICIO }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">POE</div>
                    <div class="col data">
                      {{ slotProps.data.POE }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">MODALIDAD</div>
                    <div class="col data">
                      {{
                        slotProps.data.CONFIGURABLE 
                      }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">ENLACE ENTRADA</div>
                    <div class="col data">
                      {{ slotProps.data.ENLA_ENTRADA }}
                    </div>
                  </div>
                  <div class="grid">
                    <div class="col title">ENLACE SALIDA</div>
                    <div class="col data">
                      {{ slotProps.data.ENLA_SALIDA }}
                    </div>
                  </div>
                </div>
                <div class="col-12">                
                    <div class="col title">OBSERVACIÓN</div>
                    <div class="col data">
                      {{ slotProps.data.Observacion }}
                    </div>                
                </div>
              </div>
            </template>
          </Card>
      </template>
      <template #footer>
        Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
      </template>
    </DataTable>
    <DataTable
      v-else-if="selectedUnidadFiltro && selectedUnidadFiltro.SUBRED != ''"
      :value="lstEquipos"
      v-model:expandedRows="expandedRows"
      dataKey="Id_equipo"
      v-model:filters="filters"
      :globalFilterFields="['MAC','UBICACION','NUM_SERIE','CONFIGURABLE','REF','Observacion',
      'ENLA_ENTRADA','ENLA_SALIDA','IP','MARCA','MODELO','UNIDAD','TIPO_DISPOSITIVO','SUBRED','POE']"
      :loading="loading"
      :paginator="false"      
    >
      <template #header>
        <div class="table-header-container">
            <Button icon="pi pi-plus" label="Expandir todos" @click="expandAll" class="mr-2" />
            <Button icon="pi pi-minus" label="Colapsar todos" @click="collapseAll" />
        </div>
        <div class="table-header">
          <h5>Equipos</h5>
          <span
            >Número de equipos {{ lstEquipos ? lstEquipos.length : 0 }}</span
          >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" placeholder="Buscar..." />
          </span>
        </div>
      </template>
      <template #empty> No se encontrarón registros. </template>
      <template #loading> Cargando datos. Espere por favor. </template>
      <Column :expander="true" headerStyle="width: 3rem" />
      <Column field="TIPO_DISPOSITIVO" header="TIPO_DISPOSITIVO" sortable></Column>
      <Column field="MARCA" header="MARCA" sortable></Column>
      <Column field="MODELO" header="MODELO" sortable></Column>
      <Column header="IMAGEN">
        <template #body="slotProps">
          <img
            :src="
              '/assets/modelos/' +
              slotProps.data.MODELO.toLowerCase().trim().replace(' ', '') +
              '.png'
            "
            :alt="slotProps.data.MODELO.toLowerCase().trim().replace(' ', '')"
            class="product-image"
            @click="verImg('/assets/modelos/' +
              slotProps.data.MODELO.toLowerCase().trim().replace(' ', '') +
              '.png')"
          />
        </template>
      </Column>
      <Column field="IP" header="IP" sortable>
        <template #body="slotProps">
          <span style="color:blue;cursor: pointer;" @click="pingEquipo(slotProps.data.IP)">{{ slotProps.data.IP }}</span>
        </template>
      </Column>
      <Column :exportable="false">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success"
            @click="edit(slotProps.data)"
          />
          <Button
            style="margin-left: 8px"
            icon="pi pi-times"
            class="p-button-rounded p-button-danger"
            @click="borrar(slotProps.data)"
          />
        </template>
      </Column>
      <template #expansion="slotProps">
        <Card>
          <template #content>
            <div class="grid">
              <div class="col-6">
                <div class="grid">
                  <div class="col title">Ubicación</div>
                  <div class="col data">
                    {{ slotProps.data.UBICACION }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">Num. serie</div>
                  <div class="col data">
                    {{ slotProps.data.NUM_SERIE }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MAC</div>
                  <div class="col data">
                    {{ slotProps.data.MAC }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">REFERENCIA</div>
                  <div class="col data">
                    {{ slotProps.data.REF }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">PUERTOS</div>
                  <div class="col data">
                    {{ slotProps.data.PUERTOS }}
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="grid">
                  <div class="col title">SERVICIO</div>
                  <div class="col data">
                    {{ slotProps.data.TIPO_SERVICIO }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">POE</div>
                  <div class="col data">
                    {{ slotProps.data.POE }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">MODALIDAD</div>
                  <div class="col data">
                    {{
                      slotProps.data.CONFIGURABLE 
                    }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">ENLACE ENTRADA</div>
                  <div class="col data">
                    {{ slotProps.data.ENLA_ENTRADA }}
                  </div>
                </div>
                <div class="grid">
                  <div class="col title">ENLACE SALIDA</div>
                  <div class="col data">
                    {{ slotProps.data.ENLA_SALIDA }}
                  </div>
                </div>
              </div>
              <div class="col-12">                
                  <div class="col title">OBSERVACIÓN</div>
                  <div class="col data">
                    {{ slotProps.data.Observacion }}
                  </div>                
              </div>
            </div>
          </template>
        </Card>
      </template>
      <template #footer>
        Registros en total {{ lstEquipos ? lstEquipos.length : 0 }}
      </template>
    </DataTable>

    <Dialog
      :style="{ width: '650px' }"
      :visible="showAgregar"
      :modal="true"
      class="p-fluid"
      :closable="false"
    >
      <template #header>
        <h3>{{ modoEdicion }} equipo</h3>
      </template>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="unidad">Unidad y Subred</label>
          <Dropdown
            id="unidad"
            appendTo="body"
            v-model="equipo.tUnidad"
            :options="lstUnidades"
            optionLabel="UNIDAD_SUBRED"
            placeholder="Selecciona una unidad"
            :filter="true"
            @change="escribeSUBRED"
            :class="{
              'p-invalid': submitted && !equipo.tUnidad,
            }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.tUnidad"
            >La unidad es requerida.</small
          >
        </div>

        <div class="p-field col">
          <label for="tipo">Tipo de dispositivo</label>
            <Dropdown
              id="tipo"
              appendTo="body"
              v-model="equipo.Id_tipo_dispositivo"
              :options="getTiposDispositivosOptions"
              optionLabel="Descripcion"
              optionValue="Id_tipo_dispositivo"
              placeholder="Selecciona un tipo de dispositivo"
              :class="{
                'p-invalid': submitted && !equipo.Id_tipo_dispositivo,
              }"
            />
          <small class="p-invalid" v-if="submitted && !equipo.Id_tipo_dispositivo"
            >El dispostivo es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="ubicacion">Ubicación</label>
          <InputText
            autocomplete="off"
            id="ubicacion"
            v-model.trim="equipo.UBICACION"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.UBICACION }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.UBICACION"
            >La ubicación es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="puertos">Puertos</label>
          <InputText
            autocomplete="off"
            id="puertos"
            v-model.trim="equipo.PUERTOS"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="marca">Marca</label>
          <InputText
            autocomplete="off"
            id="marca"
            v-model.trim="equipo.MARCA"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.MARCA }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.MARCA"
            >La marca es requerida.</small
          >
        </div>
        <div class="p-field col">
          <label for="modelo">Modelo</label>
          <InputText
            autocomplete="off"
            id="modelo"
            v-model.trim="equipo.MODELO"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.MODELO }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.MODELO"
            >El modelo es requerido.</small
          >
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="serie">No. serie</label>
          <InputText
            autocomplete="off"
            id="serie"
            v-model.trim="equipo.NUM_SERIE"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !equipo.NUM_SERIE }"
          />
          <small class="p-invalid" v-if="submitted && !equipo.NUM_SERIE"
            >El No. de serie es requerido.</small
          >
        </div>
        <div class="p-field col">
          <label for="mac">MAC</label>
          <InputMask
            autocomplete="off"
            id="mac"
            v-model.trim="equipo.MAC"
            mask="**:**:**:**:**:**"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
        <div class="p-field col">
          <label for="ip">IP</label>
          <InputText
            autocomplete="off"
            id="ip"
            v-model.trim="equipo.IP"
            autofocus
          />
        </div>
        <div class="p-field col">
          <label for="ref">REF</label>
          <InputText
            autocomplete="off"
            id="ref"
            v-model.trim="equipo.REF"
            autofocus
          />
        </div>
      </div>

      <div class="p-formgrid grid">
          <div class="p-field col">
              
                <label for="modalidad">Modalidad</label>
                <Dropdown
                  id="modalidad"
                  appendTo="body"
                  v-model="equipo.Id_tipo_modalidad"
                  :options="getModalidadesOptions"
                  optionLabel="Descripcion" 
                  optionValue="Id_tipo_modalidad"
                  placeholder="Selecciona una modalidad"
                  :class="{'p-invalid': submitted && !equipo.Id_tipo_servicio}"
                />
              <small class="p-invalid" v-if="submitted && !equipo.Id_tipo_servicio">
                El modalidad es requerida.
              </small>       
              
          </div>
          <div class="p-field col">
            <label for="eentrada">Enlace entrada</label>
            <InputText
              autocomplete="off"
              id="eentrada"
              v-model.trim="equipo.ENLA_ENTRADA"
              autofocus
            />
          </div>
          <div class="p-field col">
            <label for="esalida">Enlace salida</label>
            <InputText
              autocomplete="off"
              id="esalida"
              v-model.trim="equipo.ENLA_SALIDA"
              autofocus
            />
          </div>       
        </div>

      <div class="p-formgrid grid">
        <div class="p-field col-6">
          <label for="fecha_mantenimiento">Fecha de mantenimiento</label>
          <Calendar 
            id="fecha_mantenimiento" 
            v-model="equipo.tFecha_mantenimiento" 
            dateFormat="dd/mm/yy" 
          />
        </div>
        
        <div class="p-field col-6">
          <div class="grid">
            <div class="col-9">
              <label for="tipo_servicio">Tipo de servicio</label>
              <Dropdown
                id="tipo_servicio"
                appendTo="body"
                v-model="equipo.Id_tipo_servicio"
                :options="getTiposServiciosOptions"
                optionLabel="Descripcion"
                optionValue="Id_tipo_servicio"
                placeholder="Selecciona un tipo de servicio"
                :class="{'p-invalid': submitted && !equipo.Id_tipo_servicio}"
              />
              <small class="p-invalid" v-if="submitted && !equipo.Id_tipo_servicio">
                El servicio es requerido.
              </small>
            </div>
            <div class="col-3 flex align-items-center pt-4">
              <Checkbox v-model="equipo.POE" :binary="true" id="poe" />
              <label for="poe" class="ml-2">PoE</label>
            </div>
          </div>
        </div>      
      </div>

      <div class="p-field p-col">
        <label for="obs">Observación</label>
        <Textarea
          autocomplete="off"
          id="obs"
          v-model.trim="equipo.Observacion"
          autofocus
        />
      </div>       

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancelarDialogo"
        />
        <Button
          label="Guardar"
          icon="pi pi-check"
          class="p-button-text"
          @click="guardarEquipo"
        />
      </template>
    </Dialog>

    <Dialog
      :style="{ width: '650px' }"
      v-model:visible="verModelo"
      :modal="true"
      class="p-fluid"
      :closable="true"
    >
      <img :src="img">
    </Dialog>
  </div>
</template>

<script>
import Srvr from "../service/Inventario";
import axios from "axios";
import {FilterMatchMode} from 'primevue/api';
import {mapGetters} from 'vuex';
import { nextTick } from 'vue';
import Utilerias from "../utilidades/Utilerias";

export default {
  data() {
    return {
      lstUnidades: [],
      selectedUnidadFiltro: null,
      lstEquipos: null,  
      lstEquiposO: null,    
      lstTiposServicios: null,
      lstTiposDispositivos: null,
      lstModalidades: null,
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      filter:null,
      loading: true,
      submitted: false,
      showAgregar: false,
      equipoEdited: null,
      modoEdicion: "",
      expandedRows: [],
      equipo: {},
      vshowIps:[],
      verModelo: false,
      img:'',
      fieldsExport:{
        REF:"REF",
        UNIDAD:"UNIDAD",
        SUBRED:"SUBRED",
        UBICACION:"UBICACION",
        POE:"POE",
        TIPO_DISPOSITIVO:"TIPO_DISPOSITIVO",
        TIPO_SERVICIO:"TIPO_SERVICIO",
        MARCA:"MARCA",
        MODELO:"MODELO",
        PUERTOS:"PUERTOS",
        "NUMERO DE SERIE":"NUM_SERIE",
        MAC:"MAC",
        IP:"IP",        
        ENLA_ENTRADA:"ENLA_ENTRADA",
        ENLA_SALIDA:"ENLA_SALIDA",
        MODALIDAD:"CONFIGURABLE",
        Observacion:"Observacion",
      },
    };
  },
  created() {
  },
  mounted() {
    var t = this;
    t.cargaInicial();
    t.filtroInicial();
  },
  methods: {
    focusFilter() {
      nextTick(() => {
        const filterInput = document.querySelector('.p-dropdown-filter');
        if (filterInput) {
          filterInput.focus();
        }
      });
    },
    pingEquipo(host){
      var t = this;
      var ctlSrv = new Srvr();
      t.loading = true;
      t.vshowIps.push(host);
      if (host === "N/A") {
        t.loading = false;
        t.$toast.add({
          severity: "info",
          summary: "AVISO",
          detail: "No se ha especificado una dirección IP",
          life: 6000,
        });
        return;
      }
      ctlSrv.PingEquipo(t, host).then((res)=>{
      t.loading  = false;
      t.vshowIps.splice(t.vshowIps.findIndex(item=>item.IP == host));
      if(!res){
        t.$toast.add({
          severity: "success",
          summary: "AVISO",
          detail: "IP " + host + " libre, no responde a PING",
          life: 6000,
        });            
      }
      else{
        t.$toast.add({
          severity: "warn",
          summary: "AVISO",
          detail: "IP " + host + " en uso, responde a PING",
          life: 6000,
        });
      }
      });
    },
    filtroInicial(){
        this.selectedUnidadFiltro = {
          UNIDAD: "TODOS",
          SUBRED: "TODOS",
          UNIDAD_SUBRED: "TODOS",
        };
        this.cargaEquiposPorUnidad();
    },
    expandAll(){
      this.expandedRows = this.lstEquipos.filter(e=>e.Id_equipo);
    },
    collapseAll(){
      this.expandedRows = null;
    },
    forzarUpdate(){
      this.$forceUpdate();
    },
    verImg(i){
      this.verModelo = true;
      this.img = i;
    },
    cargaInicial() {
      var t = this;
      var ctlSvr = new Srvr();

      ctlSvr.getUnidades(t).then((res) => {
        t.lstUnidades = res;
        t.lstUnidades.unshift({
          UNIDAD: "TODOS",
          SUBRED: "TODOS",
          UNIDAD_SUBRED: "TODOS",
        });
      });

      ctlSvr.getTiposServicios(t).then((res) => {
        t.lstTiposServicios = res;
      });

      ctlSvr.getTiposDispositivos(t).then((res) => {
        t.lstTiposDispositivos = res;
      });
      
      ctlSvr.getModalidades(t).then((res) => {
        t.lstModalidades = res;
      });
    },
    cargaEquiposPorUnidad() {
      var t = this;
      var ctlSvr = new Srvr();
      t.lstEquipos = [];      
      if (t.selectedUnidadFiltro) {
        if (t.selectedUnidadFiltro.UNIDAD == "TODOS") {
          ctlSvr.getEquipos(t).then((res) => {
            t.loading = false;
            t.lstEquipos = res;
          });
        } else {
          ctlSvr
            .getEquiposPorSubnet(t, t.selectedUnidadFiltro.SUBRED)
            .then((res) => {
              t.loading = false;
              t.lstEquipos = res;
            
            });
        }
      }
    },   
    escribeSUBRED() {
      this.equipo.IP = "";
      if (this.equipo.tUnidad) {
        if (this.equipo.tUnidad.UNIDAD != "TODOS") {
          this.equipo.IP = this.equipo.tUnidad.SUBRED;
        }
      }
    },
    agregarEquipo() {
      this.cargaInicial();
      this.submitted = false;
      this.showAgregar = true;
      this.modoEdicion = "Agregar";
      this.equipo = { tUnidad: {} };

      if (
        this.selectedUnidadFiltro &&
        this.selectedUnidadFiltro.UNIDAD != "TODOS"
      ) {
        Object.assign(this.equipo.tUnidad, this.selectedUnidadFiltro);
        this.equipo.IP = this.selectedUnidadFiltro.SUBRED;
      }
      //this.reiniciaEquipo();
    },
    verEtiquetado() {
      var t = this;
      var file =
        "E_" +
        t.selectedUnidadFiltro.SUBRED.replace(".", "").replace(".", "") +
        ".pdf";
      var url = "/assets/etiquetados/" + file;
      
      axios.get(url).then(function(response){        
        if(response.status==200)
          window.open(url);
        else
          alert("Etiquetado en construcción");
      }).catch(function(){
        alert("Etiquetado en construcción");
      });     

      return false;
    },
    verDiagrama() {
      var t = this;
      var file =
        "D_" +
        t.selectedUnidadFiltro.SUBRED.replace(".", "").replace(".", "") +
        ".pdf";
      var url = "/assets/diagramas/" + file;

      axios.get(url).then(function(response){        
        if(response.status==200)
          window.open(url);
        else
          alert("Diagrama en construcción");
      }).catch(function(){
        alert("Diagrama en construcción");
      });      
      
      return false;
    },
    cancelarDialogo() {
      this.submitted = false;
      this.showAgregar = false;
      this.modoEdicion = "";
      this.equipo = {};
      //this.reiniciaEquipo();
    },
    edit(obj) {
      this.equipo = { ...obj };
      this.showAgregar = true;
      this.modoEdicion = "Editar";

      if(this.equipo.CONFIGURABLE) {
        const modalidadExistente = this.lstModalidades.find(
          m => m.Descripcion === this.equipo.CONFIGURABLE
        );
        
        if(modalidadExistente) {
          this.equipo.Id_tipo_modalidad = modalidadExistente.Id_tipo_modalidad;
        } else {
          this.equipo.Id_tipo_modalidad = obj.Id_tipo_modalidad;
        }
      }

      if(this.equipo.TIPO_SERVICIO) {
        const servicioExistente = this.lstTiposServicios.find(
          m => m.Descripcion === this.equipo.TIPO_SERVICIO
        );
        
        if(servicioExistente) {
          this.equipo.Id_tipo_servicio = servicioExistente.Id_tipo_servicio;
        } else {
          this.equipo.Id_tipo_servicio = obj.Id_tipo_servicio;
        }
      }

      if(this.equipo.TIPO_DISPOSITIVO) {
        const dispositivoExistente = this.lstTiposServicios.find(
          m => m.Descripcion === this.equipo.TIPO_DISPOSITIVO
        );
        
        if(dispositivoExistente) {
          this.equipo.Id_tipo_dispositivo = dispositivoExistente.Id_tipo_dispositivo;
        } else {
          this.equipo.Id_tipo_dispositivo = obj.Id_tipo_dispositivo;
        }
      }

      if(this.equipo.Fecha_mantenimiento){
        this.equipo.tFecha_mantenimiento = new Date(Date.parse(obj.Fecha_mantenimiento));
        this.equipo.tFecha_mantenimiento.setDate(this.equipo.tFecha_mantenimiento.getDate() + 1);
      }
      
      this.cargaInicial();

      this.equipo.tUnidad = {};
      let unidad = {
        UNIDAD: this.equipo.UNIDAD,
        SUBRED: this.equipo.SUBRED,
        UNIDAD_SUBRED: this.equipo.UNIDAD + " (" + this.equipo.SUBRED + ")",
      };
      this.equipo.tUnidad = unidad;

      if (this.equipo.POE == "SI") this.equipo.POE = true;
      else this.equipo.POE = false;

    },
    borrar(obj){
      var t = this;
      var ok = confirm('¿Quiere eliminar este dispositivo?');
      if(ok){
        var val =obj.Id_equipo;
        var ctlSvr = new Srvr();
        ctlSvr.deleteEquipo(t, val).then(() => {          
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo eliminado correctamente",
              life: 3000,
            });            
            t.cargaEquiposPorUnidad();          
        });
      }
    },    
    formateaFechaAMD(fecha){
      var utils = new Utilerias();
      return utils.formateaFechaAMD(fecha);
    },
    guardarEquipo() {
      var t = this;
      this.submitted = true;

      if (
        !t.equipo ||
        !t.equipo.tUnidad ||
        !t.equipo.Id_tipo_servicio ||
        !t.equipo.UBICACION ||
        !t.equipo.MARCA ||
        !t.equipo.MODELO ||
        !t.equipo.NUM_SERIE
      )
        return;

      if (t.equipo.tUnidad.UNIDAD == "TODOS") {
        t.$toast.add({
          severity: "warn",
          summary: "AVISO",
          detail: "Seleccione una unidad válida",
          life: 3000,
        });
        return;
      }

      t.equipo.UNIDAD = t.equipo.tUnidad.UNIDAD;
      t.equipo.SUBRED = t.equipo.tUnidad.SUBRED;

      const tipoEncontrado = t.lstTiposServicios.find(
        tipo => tipo.Id_tipo_servicio === t.equipo.Id_tipo_servicio
      );

      if (tipoEncontrado) {
        t.equipo.TIPO_SERVICIO = tipoEncontrado.Descripcion;
      }

      const modalidadEncontrada = t.lstModalidades.find(
        modalidad => modalidad.Id_tipo_modalidad === t.equipo.Id_tipo_modalidad
      );

      if (modalidadEncontrada) {
        t.equipo.CONFIGURABLE = modalidadEncontrada.Descripcion;
      }

      const dispositivoEncontrado = t.lstTiposDispositivos.find(
        dispositivo => dispositivo.Id_tipo_dispositivo === t.equipo.Id_tipo_dispositivo
      );

      if (dispositivoEncontrado) {
        t.equipo.TIPO_DISPOSITIVO = dispositivoEncontrado.Descripcion;
      }

      if (t.equipo.POE) t.equipo.POE = "SI";
      else t.equipo.POE = "NO";

      if (!t.equipo.REF)
        t.equipo.REF = 0;
      
      if (!t.equipo.PUERTOS)
        t.equipo.PUERTOS = 0;
      
      if(!t.equipo.ENLA_ENTRADA)
        t.equipo.ENLA_ENTRADA = "";
      
      if(!t.equipo.ENLA_SALIDA)
        t.equipo.ENLA_SALIDA = "";

      if(!t.equipo.Observacion)
        t.equipo.Observacion = "";

      if(t.equipo.tFecha_mantenimiento)
        t.equipo.Fecha_mantenimiento = t.formateaFechaAMD(t.equipo.tFecha_mantenimiento);
    
        t.equipo.Id_tipo_dispositivo = parseInt(t.equipo.Id_tipo_dispositivo, 10);
        t.equipo.Id_tipo_modalidad = parseInt(t.equipo.Id_tipo_modalidad, 10);
        t.equipo.Id_tipo_servicio = parseInt(t.equipo.Id_tipo_servicio, 10);

        console.log(t.equipo);
      // Validación de campos requeridos
      var ctlSvr = new Srvr();
      if (t.modoEdicion == "Agregar") {
        ctlSvr.addEquipo(t, t.equipo).then(() => {
          
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo agregado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposPorUnidad();
          
        });
      } else {
        ctlSvr.updateEquipo(t, t.equipo).then(() => {
          
            t.$toast.add({
              severity: "success",
              summary: "AVISO",
              detail: "Equipo editado correctamente",
              life: 3000,
            });
            t.cancelarDialogo();
            t.cargaEquiposPorUnidad();
          
        });
      }
    },
  },
  computed:{
      ...mapGetters(['getUsuarioLogueado']),
      getModalidadesOptions() {
        if (!this.lstModalidades) return [];
        
        if (this.equipo.CONFIGURABLE && 
            !this.lstModalidades.find(m => m.Descripcion === this.equipo.CONFIGURABLE)) {
          const options = [...this.lstModalidades];
          options.push({
            Id_tipo_modalidad: this.equipo.Id_tipo_modalidad || 0,
            Descripcion: this.equipo.CONFIGURABLE
          });
          return options;
        }
        
        return this.lstModalidades;
      },
      getTiposServiciosOptions() {
        if (!this.lstTiposServicios) return [];
        
        if (this.equipo.TIPO_SERVICIO && 
            !this.lstTiposServicios.find(m => m.Descripcion === this.equipo.TIPO_SERVICIO)) {
          const options = [...this.lstTiposServicios];
          options.push({
            Id_tipo_servicio: this.equipo.Id_tipo_servicio || 0,
            Descripcion: this.equipo.TIPO_SERVICIO
          });
          return options;
        }
        
        return this.lstTiposServicios;
      },
      getTiposDispositivosOptions() {
        if (!this.lstTiposDispositivos) return [];

        if (this.equipo.TIPO_DISPOSITIVO && 
            !this.lstTiposDispositivos.find(d => d.Descripcion === this.equipo.TIPO_DISPOSITIVO)) {
          const options = [...this.lstTiposDispositivos];
          options.push({
            Id_tipo_dispositivo: this.equipo.Id_tipo_dispositivo || 0,
            Descripcion: this.equipo.TIPO_DISPOSITIVO
          });
          return options;
        }
        
        return this.lstTiposDispositivos;
      }
  }, 
};
</script>

<style scoped>
.table-header {
  display: flex;
  justify-content: space-between;
  -webkit-box-pack: justify;
}
.title {
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-right: 10px;
  text-transform: uppercase;
}
.data {
  letter-spacing: 0.3px;
  margin-right: 10px;
  letter-spacing: 0.5px;
}
.product-image {
  width: 100px;  
  /* box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23); */
}
</style>

